import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { Loader2 } from 'lucide-react';
import JourneyLayout from '../../components/JourneyLayout';
import { eventToRouteMap } from '../../Utils/constants';

function RegisterNow() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [checkingAuth, setCheckingAuth] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkLoginStatus = async () => {
      setCheckingAuth(true);
      const token = localStorage.getItem('token') || 
                    localStorage.getItem('authToken') || 
                    localStorage.getItem('authtoken');
      const profileId = localStorage.getItem('profile_id') || '';
      
      if (!token || !profileId) {
        navigate('/apply-now');
        return;
      }
      setCheckingAuth(false);
    };

    checkLoginStatus();
  }, [navigate]);

  useEffect(() => {
    if (checkingAuth) return;

    const callRegisterNow = async () => {
      const profileId = localStorage.getItem('profile_id') || '';
      if (!profileId) {
        setError('Session expired. Please login again.');
        setTimeout(() => navigate('/apply-now'), 2000);
        return;
      }

      const getCurrentLocation = () =>
        new Promise((resolve) => {
          if (!navigator.geolocation) {
            resolve({ lat: '', lng: '' });
            return;
          }
          navigator.geolocation.getCurrentPosition(
            (position) => {
              resolve({
                lat: position.coords.latitude.toString(),
                lng: position.coords.longitude.toString(),
              });
            },
            () => resolve({ lat: '', lng: '' })
          );
        });

      try {
        const location = await getCurrentLocation();
        const response = await authAPI.registerNow({
          profile_id: profileId,
          geo_lat: location.lat,
          geo_long: location.lng,
        });

        if (response.Status === 1) {
          const nextEvent = response.Data?.next_step;
          if (nextEvent && eventToRouteMap[nextEvent]) {
            navigate(eventToRouteMap[nextEvent]);
          } else {
            navigate('/other-information');
          }
        } else {
          // Navigate to thank you page if registration fails
          navigate('/thank-you');
        }
      } catch (err) {
        console.error('Error calling register_now:', err);
        navigate('/thank-you');
      } finally {
        setLoading(false);
      }
    };

    callRegisterNow();
  }, [navigate, checkingAuth]);

  if (checkingAuth) {
    return (
      <JourneyLayout journeyStep={4}>
        <div className="flex items-center justify-center min-h-[400px]">
          <Loader2 className="h-8 w-8 animate-spin text-theme" />
        </div>
      </JourneyLayout>
    );
  }

  if (loading) {
    return (
      <JourneyLayout journeyStep={4}>
        <div className="text-center space-y-6 py-12">
          <div className="flex justify-center">
            <div className="bg-theme/10 p-4 rounded-full">
              <Loader2 className="h-10 w-10 text-theme animate-spin" />
            </div>
          </div>
          <h2 className="text-3xl font-bold text-gray-900">Registering you with Snap Paisa</h2>
          <p className="text-gray-600 max-w-md mx-auto">
            We're securing your session and fetching the next step. Please stay on this page.
          </p>
        </div>
      </JourneyLayout>
    );
  }

  if (error) {
    return (
      <JourneyLayout journeyStep={4}>
        <div className="text-center space-y-6 py-12">
          <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-6 max-w-md mx-auto">
            <p className="text-red-700 font-semibold">{error}</p>
            <p className="text-sm text-red-600 mt-2">Redirecting to login...</p>
          </div>
        </div>
      </JourneyLayout>
    );
  }

  return null;
}

export default RegisterNow;

